import { omniAtom } from "src/utils/atoms";

export const createTemplateModalAtom = omniAtom({
  key: "modals/createTemplate",
  value: null as null | {
    storePogId: number;
    storeCode: string;
  },
});
